import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UrlNavigationInterceptorService } from "./services/url-navigation-interceptor.service";
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { NavComponent } from './common/nav/nav.component';

/**
 * Root application component responsible for shell bootstrap, top-level layout host,
 * and global router state tracking.
 */
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, NavComponent]
})
export class AppComponent {
  private urlNavigationService = inject(UrlNavigationInterceptorService);
  private router = inject(Router);

  title = 'opus-dashboard';
  isLoggedIn: boolean = true;

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed()
    ).subscribe((event: NavigationEnd) => {
      console.log('Current URL:', event.url);
      this.isLoggedIn = event.url.includes('dashboard');
    });
  }
}

